import React from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import { Header } from "../../internal/Header/Header";
import theme from "../../../assets/theme";

const Welcome = () => {
  return (
    <Header>
      <div style={{ height: "100vh" }} className="gradient-background">
        <Center className="gradient-background">
          <Container>
            <HeadingContainer>
              <Header3>{"Welcome"}</Header3>
            </HeadingContainer>
            <Title>
              Join our industry insights and best practice advice.
              <p>Live and on-demand</p>
            </Title>
            <BodyWrap></BodyWrap>
          </Container>
        </Center>
      </div>
    </Header>
  );
};

export default Welcome;

const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-top: 10px;
  padding-bottom: 60px;
`;

export const Container = styled.div`
  // background: ${COLORS.LIGHT_BLUE_COLOR};
  border-radius: 11px;
  width: 100%;
  margin: 60px 0px;
  padding: 30px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    width: 90%;
    padding: 30px 30px;
  }
`;

const Title = styled.div`
  margin: 8px 0px;
  align-items: center;
  text-align: center;
  font-size: 14px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

const BodyWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 1%;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  font-family: ${theme.fonts.primaryFontBold};
  width: 100%;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Light = styled.div`
  margin-top: 8px;
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
`;

export const FormControl = styled.div`
  margin-bottom: 13px;
  @media ${theme?.breakpoints?.sm_up} {
    width: 236px;
    margin-top: 8px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

export const DateTime = styled.div`
  margin-top: 8px;
  font-size: 14px;
  display: flex;
  width: 216px;
  justify-content: space-between;
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${COLORS.COLOR_DARK};
`;

const Header3 = styled.h3`
  font-size: 18px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  font-family: ${theme.fonts.primaryFontExtraBold};
`;

const HeadingContainer = styled.div`
  position: relative;
  text-align: center;
`;
